// extracted by mini-css-extract-plugin
module.exports = {"container":"imageGallery-module--container--2bcpG","thumbnailHolder":"imageGallery-module--thumbnailHolder--wciBH"};